<template lang="pug">
page-template(title="Lojas")
  template(v-if="shops.length")
    grid-container.mx-auto.mb-10.justify-center(
      v-for="({ title, local, link, tel, img, text }, i) in shops",
      :key="i",
      cols="auto",
      cols-md="auto max-content",
      gap="0",
      gap-md="40px",
      style="max-width: 1000px"
    )
      div
        .text-h6.text-uppercase.accent--text.font-weight-bold.text-center.mb-4
          .pt-sans {{ title }}
        .d-flex.flex-column.mb-5
          a.text-decoration-none.grey--text.text--darken-3.mb-2(
            :href="link",
            target="_blank"
          )
            v-icon(color="primary", left) fas fa-map-marker-alt
            span {{ local }}
          a.text-decoration-none.grey--text.text--darken-3(
            :href="getTelLinkFromPhone(tel)",
            target="_blank"
          )
            v-icon(color="primary", left) fas fa-phone
            span {{ tel }}
        div(v-html="text")
      v-img.rounded(
        :src="img",
        :width="sm ? '100%' : '540px'",
        :height="sm ? 'auto' : '320px'"
      )
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import { getTelLinkFromPhone } from "@/components/utils/";

export default {
  computed: {
    shops() {
      return this.$rest("shops").list.map(
        ({ title, local, link, tel, img, text }) => ({
          img: img ? this.files + img : "",
          title,
          local,
          tel,
          text,
          link,
        })
      );
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  beforeCreate() {
    this.$rest("shops").get();
  },
  components: {
    PageTemplate,
  },
};
</script>
